import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "./ticket.css";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { GrUpdate } from "react-icons/gr";
import { RiCustomerService2Fill } from "react-icons/ri";
import { MdContentCopy } from "react-icons/md";
import { IoCheckmarkSharp } from "react-icons/io5";
import moments from "moment-timezone";
import { IoMdCheckmarkCircle } from "react-icons/io";
import axiosinstances from "../Helper/useAxios";
import moment from "moment";
import ImageModal from "../components/Model/ImageModel";
import {
  copyTextToClipboard,
  dangerColor,
  primaryColor,
  utrLeng,
} from "../utils/comman/Common";
const IMAGE = "image";
const USERUTR = "userutr";
const USERTXNDATE = "usertxnDate";
export default function TicketDeatails(props) {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const navigate = useNavigate();
  const profileInfo = useSelector(
    (state) => state.getprofilereducer?.getprofile
  );
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const [axiosInstance] = axiosinstances(userIp);
  const location = useLocation();
  console.log("location", location);
  // const { data } = location.state;
  const [data, setdata] = useState(null);
  const intialComment = data?.comments || [];
  const intialuserTxnDate = data?.userTxnDate || [];
  const [comments, setComments] = useState("");

  const [attachmentId, setattachmentId] = useState(null);
  const [imgdata, setimgData] = useState([]);
  // const [usercommants, setUserComments] = useState(data?.comments);

  const [dataLoading, setDataLoading] = useState(false);
  const [userTxDate, setUserTxDate] = useState(intialuserTxnDate);
  const [userUtrs, setUserUtrs] = useState(data?.userUtr);
  console.log("imgdata", imgdata);
  console.log("data", data);

  const e = JSON.parse(sessionStorage.getItem("token"));
  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );
  const [selectedImage, setSelectedImage] = useState(null);
  const [show, setshow] = useState(false);
  function getInitials(name) {
    if (!name) return "";

    const words = name.trim().split(" ");
    let initials = "";

    for (let i = 0; i < words.length; i++) {
      initials += words[i][0];
    }

    return initials;
  }
  console.log("selectedImage,", selectedImage);
  const getDayAgoUpdate = (updatedOn) => {
    const today = moment();

    const endMoment = moment(updatedOn);
    // Parse the dates using Moment.js

    const differenceInDays = endMoment.diff(today, "days");
    console.log("differenceInDays", differenceInDays);
    return differenceInDays;
  };
  const openImageModal = (base64Content) => {
    setSelectedImage(base64Content);
    setshow(true);
  };
  function areDatesSame(date1, date2) {
    // Check if date1 is the same as date2 (ignoring time)
    return moment(date1).isSame(date2, "day");
  }
  function calculateTimeDifference(startTime, endTime, userTimeZone) {
    const currentUserTime = moments().tz(userTimeZone);
    const startMoment = moments(startTime).tz(userTimeZone); // Assuming startTime and endTime are already in the user's time zone
    const endMoment = moments(endTime).tz(userTimeZone);
    const timeDifference = endMoment.diff(startMoment);
    const duration = moments.duration(timeDifference);

    // Format the duration
    const daysPart = duration.days() > 0 ? `${duration.days()}Days, ` : "";
    const formattedDuration = `${daysPart}${duration.hours()}:${duration.minutes()}:${duration.seconds()}`;

    return formattedDuration;
  }
  function getTodaytDateTime() {
    return moment().format("YYYY-MM-DD HH:mm:ss");
  }
  const closeImageModal = () => {
    setSelectedImage(null);
    setshow(false);
  };
  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,
  };

  // const updateTickets = async (e) => {
  //   e.preventDefault();
  //   const requestPayload = {
  //      ticketId : data?.id,
  //      updatedBy : profileInfo?.id,
  //      userUtr : ticketRequest?.userUtr,
  //      userTxnDate : ticketRequest.userTxnDate,
  //      comments : ticketRequest?.comments,
  //      attachmentId : attachmentId?.id,
  //     //  internalComments : "",
  //     //  internalAttachmentId : "",
  //      status : ticketRequest?.status

  //   };
  //   if( ticketRequest?.comments == ''){
  //     toast.error("Enter Your Comments");
  //     return;
  //   }
  //   if(!validateUTR(ticketRequest?.userUtr)){
  //     toast.error("Utr is not valid");
  //     return;
  //   }

  //   if(requestPayload?.ticketId == null || requestPayload?.ticketId == ''){
  //     toast.error("ticketId is required to fill");
  //     return;
  //   }
  //   if(requestPayload?.status == null || requestPayload?.status == '' ){
  //     toast.error("status is not Valid and its required to fill");
  //     return;
  //   }

  //   //userTxnDate
  //   if(requestPayload?.userTxnDate == '' ){
  //     toast.error("User Txn Date By is not Valid and its required to fill");
  //     return;
  //   }

  //   setDataLoading(true);
  //   const API_ENDPOINT = "/api/v1/upi/ticket/update";
  //   try {

  //     const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
  //       headers,
  //     });

  //     if (response.status === 200 && response?.data?.id !== undefined) {

  //       toast.success(`Your ticket has raised and ref is ${response?.data?.id}`);
  //       request["fromDate"] = fromatedFromDate;
  //   request["toDate"] = formatedToDate;
  //   request["statuses"] = finalStatus;
  //   request["pageNum"] = paginationDetails.currentPage - 1;
  //   request["perPage"] = paginationDetails.postsPerPage;

  //   if (url && request) {
  //     callApis(url, request);
  //   }
  //       setDataLoading(false);
  //       handleClose()
  //     } else {
  //       setDataLoading(false);
  //       throw new Error(response?.response?.data?.message);
  //     }
  //   } catch (error) {
  //     setDataLoading(false);
  //     console.error("Error fetching data:", error);

  //     toast.error(error?.message);
  //     return false;
  //   }

  // };
  const fetchTicketDetails = async (id) => {
    const newData = [];
    const API_ENDPOINT = `/api/v1/upi/ticket/get/${id}`;
    try {
      const response = await axiosInstance.get(`${API_ENDPOINT}`, {
        headers,
      });
      const ticketValues = response.data;
      console.log("ticketValues", ticketValues);
      if (Array.isArray(ticketValues?.tickets)) {
        console.log("ticketValues?.tickets[0]", ticketValues?.tickets[0]);
        setdata(ticketValues?.tickets[0]);
        setUserUtrs(ticketValues?.tickets[0]?.userUtr);
        setUserTxDate(ticketValues?.tickets[0]?.userTxnDate);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    if (location.state?.data?.id !== undefined) {
      fetchTicketDetails(location.state?.data?.id);
    }
  }, []);

  useEffect(() => {
    if (data?.attachments !== undefined) {
      const fetchData = async () => {
        const newData = [];
        const API_ENDPOINT = "/api/v1/upi/file/fetch";
        for (const value of Object.values(data?.attachments)) {
          try {
            const response = await axiosInstance.get(
              `${API_ENDPOINT}/${value}/base64`,
              {
                headers,
              }
            );
            const stringToEncode = response.data;

            newData.push(stringToEncode);
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        }

        setimgData(newData);
      };

      fetchData();
    }
  }, [data?.attachments]);

  const submitComment = async (e) => {
    e.preventDefault();
    const requestPayload = {
      ticketId: data?.id,
      updatedBy: profileInfo?.id,
      comments: comments,
      status: data?.status,
    };

    if (comments == "") {
      toast.error("Enter Your Comments");
      return;
    }

    setDataLoading(true);
    const API_ENDPOINT = "/api/v1/upi/ticket/update";
    try {
      const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
        headers,
      });

      if (response.status === 200 && response?.data?.id !== undefined) {
        toast.success(`Your comment ref is ${response?.data?.id}`);
        // setUserComments(response?.data?.comments);
        // setdata(response?.data);
        // setComments("");
        fetchTicketDetails(response?.data?.id);
        setDataLoading(false);
      } else {
        setDataLoading(false);
        throw new Error(response?.response?.data?.message);
      }
    } catch (error) {
      setDataLoading(false);
      console.error("Error fetching data:", error);

      toast.error(error?.message);
      return false;
    }
  };
  const updateNewChange = async (item, check) => {
    // e.preventDefault();

    const requestPayload = {
      ticketId: data?.id,
      updatedBy: profileInfo?.id,
      // comments: "",
      status: data?.status,
      userUtr: userUtrs,
      userTxnDate: userTxDate,
    };
    if (check == IMAGE) {
      requestPayload.attachmentId = item;
    }

    // if(check == USERUTR){
    //   requestPayload.userUtr = item; //userUtrs
    // }
    // if(check == USERTXNDATE){
    //   requestPayload.userTxnDate = item;
    // }
    setDataLoading(true);
    const API_ENDPOINT = "/api/v1/upi/ticket/update";
    try {
      const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
        headers,
      });

      if (response.status === 200 && response?.data?.id !== undefined) {
        toast.success(`Your comment ref is ${response?.data?.id}`);
        // setdata(response?.data);
        fetchTicketDetails(response?.data?.id);

        setDataLoading(false);
      } else {
        setDataLoading(false);
        throw new Error(response?.response?.data?.message);
      }
    } catch (error) {
      setDataLoading(false);
      console.error("Error fetching data:", error);

      toast.error(error?.message);
      return false;
    }
  };
  const uploadFile = async (files) => {
    if (!files) {
      console.error("No file selected");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", files);
      const url = "/api/v1/upi/file/upload/1209600";
      const response = await axiosInstance.post(url, formData, { headers });

      if (response.status == 200 && response.data?.id !== undefined) {
        console.log("File uploaded successfully", response.data);
        // Optionally handle response data
        toast.success("File has added");
        updateNewChange(response?.data?.id, IMAGE);
        // setattachmentId(response.data);
        return response;
      } else {
        toast.error(
          "unable to upload image and file permitted size is 1048576 bytes"
        );
        console.error("Failed to upload file");
      }
    } catch (error) {
      toast.error("Error uploading file:", error);
      console.error("Error uploading file:", error);
    }
  };
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const res = await uploadFile(file);
  };
  function validateUTR(utr) {
    // Check if UTR is exactly 12 digits
    if (!/^\d{12}$/.test(utr)) {
      return false;
    }

    // Get the last digit of the current year
    const currentYearLastDigit = new Date().getFullYear().toString().slice(-1);

    // Get the last two digits of the previous year
    const previousYearLastTwoDigits = (new Date().getFullYear() - 1)
      .toString()
      .slice(-2);

    // Get the current month and day
    const currentMonth = new Date().getMonth() + 1; // Add 1 to get the month number (January is 1, December is 12)
    const currentDay = new Date().getDate();

    // Check if today is January 1st and the UTR corresponds to December 31st of the previous year
    if (currentMonth === 1 && currentDay === 1) {
      // customLog("utr", utr);
      // customLog(utr[0], previousYearLastTwoDigits[1]);
      if (utr[0] === previousYearLastTwoDigits[1]) {
        return true;
      }
    }

    // Check if the first digit of the UTR matches the last digit of the current year
    if (utr[0] !== currentYearLastDigit) {
      return false;
    }

    return true;
  }

  const handleChangeUtr = ({ target }) => {
    const inputValue = target.value;

    // Remove any non-numeric characters from the input value
    const numericValue = inputValue.replace(/\D/g, "");
    // customLog("numericValue", numericValue);
    // Update the input value and display an error message if necessary

    if (numericValue == "") {
      setUserUtrs("");
    }
    if (Number.isInteger(parseInt(numericValue))) {
      setUserUtrs(numericValue);
    }
  };
  return (
    <div>
      {/* <nav class="navbar navbar-expand-lg bg-white fixed-top ">
        <div class="container-fluid">

            <a class="navbar-brand align-self-baseline" href="#"><i class="fa-solid fa-bars me-3"></i>Jira Software</a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02"
                aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0 text-dark">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-dark content-hover" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Your Work
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li>
                                <hr class="dropdown-divider"/>
                            </li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-dark content-hover" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Projects
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li>
                                <hr class="dropdown-divider"/>
                            </li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-dark content-hover" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Filters
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li>
                                <hr class="dropdown-divider"/>
                            </li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-dark content-hover" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Dashboard
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li>
                                <hr class="dropdown-divider"/>
                            </li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-dark content-hover" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Teams
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li>
                                <hr class="dropdown-divider"/>
                            </li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-dark content-hover" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Apps
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li>
                                <hr class="dropdown-divider"/>
                            </li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link active" aria-current="page" href="#">
                            <button class="btn bg-primary p-0 px-1  text-white " data-bs-toggle="modal"
                                data-bs-target="#exampleModal">Create</button></a>
                    </li>
                </ul>
                <form class="d-flex" role="search">
                    <input class="form-control " type="search" placeholder="Search" aria-label="Search"/>
                    <button class="btn m-0 p-0 " type="submit"><i
                            class="fa-solid fa-bell content-hover p-2"></i></button>
                    <button class="btn m-0 p-0 " type="submit"><i
                            class="fa-solid fa-question content-hover p-2"></i></button>
                    <button class="btn m-0 p-0 " type="submit"><i
                            class="fa-solid fa-gear content-hover p-2"></i></button>
                    <div class="bg-primary rounded-circle text-white w-25 h-25 py-2 text-center">
                        CT
                    </div>
                </form>
            </div>
        </div>
    </nav> */}
      {/* <!-- Modal --> */}
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div class="modal-content">
            {/* <!-- model header --> */}
            <div class="modal-header d-flex ">
              <div>
                <h1 class="modal-title fs-5" id="exampleModalLabel">
                  Create Issue
                </h1>
              </div>
              <div>
                <button type="button" class="btn">
                  <i class="fa fa-minus fs-5"></i>
                </button>
                <button type="button" class="btn">
                  <i class="fa-solid fa-arrow-down fs-5"></i>
                </button>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
            </div>
            {/* <!-- model body --> */}
            <div class="modal-body">
              <div class="container">
                {/* <!-- project  first row --> */}
                <div class="row">
                  <div class="col-6">
                    <div class="project-model">
                      <label for="">
                        Project <span class="text-danger">*</span>
                      </label>
                      <select name="" id="" class="form-select mb-3 bg-light">
                        <option value="">option1</option>
                        <option value="">option2</option>
                        <option value="">option3</option>
                      </select>

                      <label for="">
                        Issue Type<span class="text-danger">*</span>
                      </label>
                      <select name="" id="" class="form-select bg-light">
                        <option value="">
                          <i
                            class="fa-solid fa-square-check"
                            style={{ color: "#7ea6ec" }}
                          ></i>{" "}
                          Task
                        </option>
                        <option value="">option2</option>
                        <option value="">option3</option>
                      </select>
                      <a href="#">Learn More</a>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="d-flex justify-content-end">
                      <button type="button" class="btn text-primary">
                        <i
                          class="fa-solid fa-eye"
                          style={{ color: "#093177" }}
                        ></i>
                        1
                      </button>
                      <button type="button" class="btn">
                        Import Issue
                      </button>
                      <button type="button" class="btn">
                        <i class="fa fa-ellipsis"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                {/* <!-- status Secoond row --> */}
                <div class="row">
                  {/* <!-- Status --> */}
                  <div class="col-12">
                    <label for="">
                      Status{" "}
                      <span>
                        <i class="fa fa-circle-info"></i>
                      </span>
                    </label>
                  </div>
                  <div class="col-12  mb-3 status">
                    <select name="" id="" class="mb-1 bg-light form-select-sm">
                      <option value="">To Do</option>
                      <option value="">option2</option>
                      <option value="">option3</option>
                    </select>
                    <p class="text-secondary m-0 p-0 fw-semibold">
                      This is the issue's initial status upon creation
                    </p>
                  </div>
                  {/* <!-- Summary --> */}
                  <div class="col-12  mb-3">
                    <label for="">
                      Summary <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name=""
                      id=""
                      class="form-control border inputbg border-2"
                    />
                  </div>
                  {/* <!-- Description --> */}
                  <div class="col-12 mb-3">
                    <label for="">Description</label>
                    <textarea
                      name=""
                      id=""
                      cols="30"
                      rows="5"
                      class="form-control"
                    ></textarea>
                  </div>
                  {/* <!-- Assignee --> */}

                  <div class="col-6 mb-3">
                    <label for="">Assignee</label>
                    <div class=" border border-2 bg-light p-1">
                      <i
                        class="fa-solid fa-circle-user fs-5"
                        style={{ color: "#a5a5a6" }}
                      ></i>
                      <input
                        type="text"
                        name=""
                        id=""
                        placeholder="Automatic"
                        class="border-0 bg-light "
                      />
                    </div>
                    <span>
                      <a href="" class="text-decoration-none fw-semibold">
                        Assign to me
                      </a>
                    </span>
                  </div>

                  {/* <!-- labels --> */}
                  <div class="col-12  ">
                    <label for="">labels</label>
                  </div>
                  <div class="col-6  mb-3">
                    <div>
                      <select name="" id="" class="mb-1 form-select bg-light">
                        <option value="">Select label</option>
                        <option value="">option2</option>
                        <option value="">option3</option>
                      </select>
                    </div>
                  </div>

                  {/* <!-- Reporter --> */}
                  <div class="col-12">
                    <label for="">
                      Reporter <span class="text-danger">*</span>
                    </label>
                  </div>
                  <div class="col-6 mb-3">
                    <div class=" border border-2 bg-light p-1 d-flex">
                      <div class=" rounded-circle  text-center bg-primary text-white">
                        CT
                      </div>
                      <input
                        type="text"
                        name=""
                        id=""
                        placeholder="CodeFirst Text"
                        class="border-0 bg-light "
                      />
                    </div>
                  </div>
                  {/* <!-- Attachment --> */}
                  <div class="col-12 mb-3">
                    <label for="">Attachment</label>
                    <div class="border border-dotted text-center p-5">
                      <span>
                        <i class="fa fa-cloud-arrow-up"></i>Drop files to attach
                        or{" "}
                        <a href="#" class="text-decoration-none">
                          browse
                        </a>
                      </span>
                    </div>
                  </div>
                  {/* <!-- Linked Issues --> */}
                  <div class="col-6 mb-3">
                    <div>
                      <label for="">Linked Issues</label>
                      <select name="" id="" class="mb-1 form-select bg-light">
                        <option value="">Select label</option>
                        <option value="">option2</option>
                        <option value="">option3</option>
                      </select>
                      <select name="" id="" class="mb-1 form-select bg-light">
                        <option value="">Select label</option>
                        <option value="">option2</option>
                        <option value="">option3</option>
                      </select>
                    </div>
                  </div>
                  {/* <!-- Flagged --> */}
                  <div class="col-12">
                    <label for="">Flagged</label>
                  </div>
                  <div class="col-6 mb-3">
                    <div class=" rounded-2 bg-light border border-2 d-flex justify-content-between">
                      <input
                        type="text"
                        name=""
                        id=""
                        class="border-0 bg-light form-control"
                      />
                      <button class="btn border-0">
                        <i class="fa fa-chevron-down"></i>
                      </button>
                    </div>
                    <p class="text-secondary fw-semibold">
                      Allows to flag issues with impediments.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- model footer --> */}
            <div class="modal-footer justify-content-between">
              <div>
                <input type="checkbox" name="" id="" />
                <span>Create another issue</span>
              </div>
              <div>
                <button
                  type="button"
                  class="btn btn-light"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button type="button" class="btn btn-primary">
                  Create
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- main content --> */}
      <section class="pt-3">
        <div class=" container-fluid">
          <div class="row ">
            <div class="col-lg-8 col-md-12 first-col">
              <div class="border border-top-0 px-3">
                <div class="row">
                  {/* <div class="col-lg-12 col-md-12">
                                <div>
                                    <nav aria-label="breadcrumb ">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><a class="text-decoration-none text-muted"
                                                    href="#">Projects</a>
                                            </li>
                                            <li class="breadcrumb-item"><a class="text-decoration-none text-muted"
                                                    href="#">Glitch-Found</a>
                                            </li>
                                            <li class="breadcrumb-item "><i class="fa fa-pencil"></i><a
                                                    class="text-decoration-none text-muted" href="#">Add-epic</a></li>
                                            <li class="breadcrumb-item active" aria-current="page">
                                                <input type="checkbox" name="" id=""/><span> <a
                                                        class="text-decoration-none text-muted"
                                                        href="#">GF-20</a></span>
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                            </div> */}
                  {/* <div class="col-lg-12 col-md-12 ">
                                <div class="heading-hover">
                                    <h1>Extra Fields in Ticket Creation</h1>
                                </div>
                            </div> */}
                  {/* <div class="col-lg-12 col-md-12">
                                <div>
                                    <button type="button" class="btn btn-light attach me-1"><i
                                            class="fa-solid fa-paperclip"></i>Attach</button>
                                    <button type="button" class="btn btn-light child-issue me-1">Add a child
                                        issue</button>
                                    <button type="button" class="btn btn-light link-issue "><i
                                            class="fa-solid fa-link"></i>Link
                                        issue
                                    </button>
                                    <button type="button" class="btn btn-light down-arrow border-start "><i
                                            class="fa fa-angle-down"></i></button>
                                </div>
                            </div> */}

                  <div class="col-lg-12 col-md-12 mt-3 desciption">
                    <p class="fw-bold pb-2 m-0">Txn Details</p>
                    <div className="txn-item" key={data?.id}>
                      <div className="txn-head" id="txnhead1">
                        <div
                          className="collapsed"
                          data-bs-toggle="collapse"
                          data-bs-target="#txn1"
                          aria-expanded="false"
                          aria-controls="txn1"
                        >
                          <div
                            className={`txncard ${
                              data?.resolved ? "success grbg" : "pending ylbg"
                            }`}
                          >
                            <div className="row">
                              <div className="col-12 col-md-2">
                                <div className="txntxt">
                                  <h6>
                                    <span>
                                      {" "}
                                      {data?.createdOn !== undefined &&
                                        data?.createdOn !== null &&
                                        data?.createdOn
                                          .replace("T", " ")
                                          .slice(0, -4)}{" "}
                                    </span>{" "}
                                    {/* ₹ {data.transaction.amount}{" "} */}
                                  </h6>
                                  <h6>{data?.payInTxn?.receivingVpa}</h6>
                                  <h6>{data?.payInTxn?.bank} </h6>
                                </div>
                              </div>
                              <div className={`col-12 col-md-4`}>
                                <div
                                  className="txntxt"
                                  onClick={() =>
                                    copyTextToClipboard(
                                      data?.payInTxn?.requestId,
                                      toast
                                    )
                                  }
                                >
                                  <h6>
                                    ReqID: {data?.payInTxn?.requestId}{" "}
                                    {/* <MdContentCopy
                                                    style={{
                                                      color: primaryColor,
                                                    }}
                                                  /> */}
                                  </h6>

                                  {/* </li> */}
                                </div>
                                <div
                                  className="txntxt"
                                  onClick={() =>
                                    copyTextToClipboard(
                                      data?.payInTxn?.id,
                                      toast
                                    )
                                  }
                                >
                                  <h6>TxnID: {data?.payInTxn?.id} </h6>
                                </div>

                                <div className="txntxt">
                                  <h6 style={{ position: "relative" }}>
                                    UserUtr:
                                    <input
                                      style={{
                                        border: "#E3E3E3",
                                        borderRadius: "5px",
                                        paddingLeft: "3px",
                                        position: "relative",
                                        width: "80%",
                                      }}
                                      type={"text"}
                                      pattern="[0-9]*"
                                      maxLength={12}
                                      value={userUtrs}
                                      onChange={handleChangeUtr}
                                    />
                                    <button
                                      style={{
                                        position: "absolute",
                                        top: "50%",
                                        right: "5px",
                                        transform: "translateY(-50%)",
                                        border: "none",
                                        background: "none",
                                      }}
                                      type="button"
                                      disabled={
                                        !(
                                          userUtrs !== data?.userUtr &&
                                          validateUTR(userUtrs)
                                        )
                                      }
                                      onClick={() =>
                                        updateNewChange(userUtrs, USERUTR)
                                      }
                                    >
                                      <IoMdCheckmarkCircle
                                        size={30}
                                        style={
                                          userUtrs !== data?.userUtr &&
                                          validateUTR(userUtrs)
                                            ? { color: primaryColor }
                                            : { color: "#E3E3E3" }
                                        }
                                      />
                                    </button>
                                  </h6>
                                </div>
                              </div>

                              <div
                                // className="col-12 col-md-3"
                                className="col-12 col-md-4"
                              >
                                <div className="txntxt">
                                  <h6
                                    onClick={() =>
                                      copyTextToClipboard(
                                        utrLeng(data?.payInTxn?.utr),
                                        toast
                                      )
                                    }
                                  >
                                    UTR:{utrLeng(data?.payInTxn?.utr)}
                                    {/* <MdContentCopy
                                                    style={{
                                                      color: primaryColor,
                                                    }}
                                                  /> */}
                                  </h6>
                                  <h6
                                    onClick={() =>
                                      copyTextToClipboard(
                                        data?.payInTxn?.orderCode,
                                        toast
                                      )
                                    }
                                  >
                                    OrdCode: {data?.payInTxn?.orderCode}
                                  </h6>
                                  <h6 style={{ position: "relative" }}>
                                    UsrTxnDate:
                                    <span>
                                      {" "}
                                      {
                                        data?.userTxnDate !== undefined &&
                                          data?.userTxnDate !== null && (
                                            <>
                                              <input
                                                style={{
                                                  border: "#E3E3E3",
                                                  borderRadius: "5px",
                                                  paddingLeft: "3px",
                                                  position: "relative",
                                                  width: "60%",
                                                }}
                                                onChange={(e) =>
                                                  setUserTxDate(e.target.value)
                                                }
                                                type="date"
                                                value={userTxDate}
                                              />
                                              <button
                                                style={{
                                                  position: "absolute",
                                                  top: "50%",
                                                  right: "5px",
                                                  transform: "translateY(-50%)",
                                                  border: "none",
                                                  background: "none",
                                                }}
                                                disabled={areDatesSame(
                                                  userTxDate,
                                                  data?.userTxnDate
                                                )}
                                                type="button"
                                                onClick={() =>
                                                  updateNewChange(
                                                    userTxDate,
                                                    USERTXNDATE
                                                  )
                                                }
                                              >
                                                <IoMdCheckmarkCircle
                                                  size={30}
                                                  style={
                                                    !areDatesSame(
                                                      userTxDate,
                                                      data?.userTxnDate
                                                    )
                                                      ? { color: primaryColor }
                                                      : { color: "#E3E3E3" }
                                                  }
                                                />
                                              </button>
                                            </>
                                          )
                                        //   <input
                                        //   value={data?.userTxnDate}
                                        //   type="date"
                                        //   // onChange={tokenChangeHandle}
                                        //   name="userTxnDate"
                                        //   id=""
                                        //   // class="form-control border inputbg "
                                        // />
                                      }
                                    </span>{" "}
                                    {/* ₹ {data.transaction.amount}{" "} */}
                                  </h6>
                                </div>
                              </div>

                              <div className="col-12 col-md-2">
                                <div className="txntxt">
                                  <h4>
                                    ₹ {data?.payInTxn?.transaction?.amount}
                                  </h4>

                                  {/* <h4>
                                    PsdAmt ₹ {data?.payInTxn?.processedAmount}
                                  </h4> */}
                                  <h4>
                                    {" "}
                                    <span
                                      className={`${
                                        data?.status === "SUCCESS_AUTO" ||
                                        data?.status === "SUCCESS_MANUAL"
                                          ? "success"
                                          : `${
                                              data?.status ===
                                                "PENDING_PAYMENT" ||
                                              data?.status ===
                                                "PAYMENT_PROCESSED" ||
                                              data?.status === "HUNG" ||
                                              data?.status === "ACCEPTED"
                                                ? "pending"
                                                : "failed"
                                            }`
                                      }`}
                                    >
                                      {data?.status}
                                    </span>
                                  </h4>
                                  {/* )} */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div class="description-div  pb-3 px-1 ">
                    <ul >
                       <li > Txn id : {data?.payInTxn?.id} </li>
                       <li > Merchant Id :  {data?.payInTxn?.merchantId}  </li>  
                       <li > Request Id :  {data?.payInTxn?.requestId}  </li>  
                       <li > Bank :  {data?.payInTxn?.bank}  </li> 
                       <li > status :  {data?.payInTxn?.status}  </li> 
                        
                                  
                    </ul>
                    </div> */}
                  </div>
                  <div class="col-lg-12 col-md-12 mt-3 desciption">
                    <p class="fw-bold pb-2 m-0">Description</p>
                    <div class="description-div  pb-3 px-1 ">
                      <p>{data?.description}</p>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 mt-5">
                    <div class="attachment d-flex justify-content-between align-items-center">
                      <div>
                        <p class="fw-semibold">
                          Attachment (
                          {Array.isArray(imgdata) && imgdata.length > 0
                            ? imgdata.length
                            : 0}
                          )
                        </p>
                      </div>

                      {/* <div class="">
                        <button
                          type="button"
                          class="btn btn-light down-arrow border-start "
                        >
                          <i class="fa-solid fa-ellipsis"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-light down-arrow border-start "
                        >
                          <i class="fa-solid fa-plus"></i>
                        </button>
                      </div> */}
                    </div>
                  </div>
                  <div class="col-12 mb-3">
                    <div>
                      <label htmlFor="attachment">Attachment</label>
                      <div className="border border-dotted text-center p-5">
                        <label
                          htmlFor="fileInput"
                          className="text-decoration-none"
                        >
                          <i className="fa fa-cloud-arrow-up"></i>Drop files to
                          attach or browse
                        </label>
                        <input
                          type="file"
                          id="fileInput"
                          accept="image/png, image/jpeg"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        />
                        {attachmentId?.name !== undefined &&
                          attachmentId?.name !== null && (
                            <p>Selected file: {attachmentId?.name}</p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 attachment-card">
                    {Array.isArray(imgdata) && imgdata.length > 0 ? (
                      imgdata.map((val, index) => (
                        <div
                          key={index}
                          className="card"
                          style={{
                            height: "100px",
                            width: "150px",
                            cursor: "pointer",
                          }}
                        >
                          <div>
                            <img
                              onClick={() => openImageModal(val?.base64Content)}
                              style={{ height: "100px", width: "150px" }}
                              src={`data:image/jpeg;base64,${val?.base64Content}`}
                              className="card-img-top"
                              alt={`Attachment ${index}`}
                            />
                          </div>
                          {/* <div className="card-footer">
                            <p className="fw-bold m-0">{val?.name}</p>
                            <p className="text-muted m-0">
                              Created on{" "}
                              {moment(val?.createdOn).format(
                                "DD-MM-YYYY hh:mm:ss"
                              )}
                            </p>
                            <p className="text-muted m-0">
                              Expire on{" "}
                              {moment(val?.expireOn).format(
                                "DD-MM-YYYY hh:mm:ss"
                              )}
                            </p>
                          </div> */}
                        </div>
                      ))
                    ) : (
                      <p>No attachments found</p>
                    )}

                    {show && (
                      <ImageModal
                        show={show}
                        base64Content={selectedImage}
                        handleClose={closeImageModal}
                      />
                    )}
                  </div>

                  <div class="col-lg-12 col-md-12 mt-5">
                    {/* <p class="fw-semibold">Activity</p> */}
                    <hr />
                    <div class="d-flex justify-content-between">
                      <div>
                        <span style={{ marginRight: "5px" }}>Show :</span>
                        {/* <button type="button" class="btn btn-light attach me-2">
                          {" "}
                          All
                        </button> */}
                        <button
                          type="button"
                          class="btn btn-light attach me-2 active commnets-btn"
                        >
                          Comments
                        </button>
                        {/* <button type="button" class="btn btn-light attach me-2">
                          {" "}
                          History
                        </button> */}
                      </div>

                      {/* <div>
                        <button type="button" class="btn btn-light attach me-2">
                          <i class="fa  fa-bars-sort"></i>
                          Order First{" "}
                        </button>
                      </div> */}
                    </div>
                  </div>

                  <div class="col-lg-12 col-md-12 mt-4">
                    <div class="row activity">
                      <div class="col-lg-1 col-md-1  "></div>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 mt-2">
                    <div class="row activity">
                      <div class="col-lg-1 col-md-1   "></div>
                    </div>
                  </div>

                  {Array.isArray(data?.comments) &&
                    data?.comments.length > 0 &&
                    data?.comments.map((comt) => (
                      <div class="col-lg-12 col-md-12 mt-2">
                        <div class="row activity">
                          <div class="col-lg-1 col-md-1   ">
                            <div class="rounded-circle bg-primary text-center  w-75 py-1">
                              <p class="text-white">{getInitials(comt?.by)}</p>
                            </div>
                          </div>
                          <div class="col-lg-11 col-md-11">
                            <div class="d-flex">
                              <p class="me-3 fw-semibold">{comt?.by}</p>
                              <p>
                                {moment(comt?.ts).format("DD-MM-YYYY hh:mm:ss")}
                              </p>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                              <p>{comt?.text}</p>
                              {/* <p>
                            <a
                              class="me-1 text-decoration-none text-muted fw-semibold"
                              href="#"
                            >
                              Edit
                            </a>
                            .
                            <a
                              class="me-1 text-decoration-none text-muted fw-semibold"
                              href="#"
                            >
                              Delete
                            </a>
                            .
                            <button
                              type="button"
                              class="btn btn-light attach me-1"
                            >
                              <i class="fa-solid fa-face-smile"></i>
                            </button>
                          </p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  <div class="col-lg-12 col-md-12 mt-2 ">
                    <div class="row activity">
                      <div class="col-lg-1 col-md-1  ">
                        <div
                          style={{ marginTop: "10px" }}
                          class="rounded-circle bg-primary text-center   w-75 py-1"
                        >
                          <p class="text-white">
                            {getInitials(profileInfo?.id)}
                          </p>
                        </div>
                      </div>
                      <div
                        style={{ marginBottom: "5px" }}
                        class="col-lg-11 col-md-11 mt-2"
                      >
                        <div style={{ display: "flex" }} class=" comment">
                          <input
                            onChange={(e) => setComments(e.target.value)}
                            type="text"
                            name=""
                            id=""
                            value={comments}
                            placeholder="Add Comments...."
                            class="form-control"
                          />
                          <button
                            style={{ marginLeft: "5px", float: "right" }}
                            onClick={submitComment}
                            type="button"
                            class="btn btn-primary"
                          >
                            {" "}
                            Comment
                          </button>
                          {/* <p class=""><span class="fw-bold">Pro Tip :</span> press
                                                <button onClick={submitComment} type="button" class="btn btn-secondary me-2"> M</button>to
                                                comment1
                                            </p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- seccond column --> */}
            <div class="col-lg-4 col-md-12 second-col">
              <div class="container">
                <div class="row mt-5">
                  {/* <div class="col-12">
                    <div class="d-flex justify-content-end">
                      <button type="button" class="btn btn-light attach me-1">
                        <i class="fa-solid fa-eye"></i>2
                      </button>
                      <button type="button" class="btn btn-light attach me-1">
                        <i class="fa-solid fa-thumbs-up"></i>
                      </button>
                      <button type="button" class="btn btn-light attach me-1">
                        <i class="fa-solid fa-share-nodes"></i>
                      </button>
                      <button type="button" class="btn btn-light attach me-1">
                        <i class="fa-solid fa-ellipsis"></i>
                      </button>
                    </div>
                  </div> */}
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12">
                    <div>
                      <button
                        type="button"
                        class="btn btn-light active attach me-1"
                      >
                        {data?.status}
                        <i class="fa fa-angle-down ms-2"></i>
                      </button>
                      {/* <button
                        type="button"
                        class="btn btn-light active attach me-1"
                        style={{
                          color: data?.resolved ? primaryColor : dangerColor,
                        }}
                      >
                        {data?.resolved ? "RESOLVED" : "UNRESOLVED"}
                        <i class="fa fa-angle-down ms-2"></i>
                      </button> */}
                      {/* <button type="button" class="btn btn-light attach me-1">
                        <i class="fa-solid fa-bolt me-2"></i>{data?.resolved ? "RESOLVED": "UNRESOLVED"}
                        <i class="fa fa-angle-down ms-2"></i>
                      </button> */}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12">
                    <div class="mt-3">
                      <div class="card">
                        {/* <div class="card-header bg-white d-flex justify-content-between">
                          <p>Your pinned fields</p>
                          <span>
                            <i class="fa fa-angle-down ms-2"></i>
                          </span>
                        </div> */}
                        <div class="card-body">
                          <div class="row">
                            <div class="col-lg-6 col-md-6">
                              <p class="fw-bold text-secondary">Assignee</p>
                            </div>
                            <div class="col-lg-6 col-md-6 align-items-center">
                              <div class="d-flex">
                                <i class="fa-solid fa-circle-user fs-3 me-2"></i>
                                <span>
                                  {" "}
                                  {data?.assignedTo !== undefined &&
                                  data?.assignedTo !== null
                                    ? data?.assignedTo
                                    : "UnAssigned"}{" "}
                                </span>
                              </div>
                              {/* <div class="row">
                                <div class="col-lg-12 col-md-12">
                                  <a href="#" class="text-decoration-none">
                                    Assign to me
                                  </a>
                                </div>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12">
                    <div class="mt-3">
                      <div class="card">
                        <div class="card-header bg-white d-flex justify-content-between">
                          <p>Details</p>
                          <span>
                            <i class="fa fa-angle-down ms-2"></i>
                          </span>
                        </div>
                        <div class="card-body">
                          <div class="row">
                            <div class="col-lg-6 col-md-6">
                              <p class="fw-bold text-secondary">Created By</p>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <p class="fw-bold text-secondary">
                                {data?.createdBy}
                              </p>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <p class="fw-bold text-secondary">Created On</p>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <p class="fw-bold text-secondary">
                                {data?.createdOn !== undefined &&
                                  moment(data?.createdOn).format(
                                    "YYYY-MM-DD HH:mm:ss"
                                  )}
                              </p>
                            </div>

                            {/* <div class="col-lg-6 col-md-6">
                              <p class="fw-bold text-secondary">Assigned To</p>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="row">
                                <div class="d-flex align-items-center">
                                  <div class="col-lg-4 col-md-4">
                                    <div class="rounded-circle bg-primary text-center w-75 ">
                                      <p class="text-white m-0 p-0">{getInitials(data?.assignedTo) || "NA"}</p>
                                    </div>
                                  </div>
                                  <div class="col-lg-9 col-md-9">
                                    <div>
                                      <p class="ms-2">{data?.assignedTo}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> */}
                            <div class="col-lg-6 col-md-6">
                              <p class="fw-bold text-secondary">Closed By</p>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="row">
                                <div class="d-flex align-items-center">
                                  <div class="col-lg-4 col-md-4">
                                    {data?.closedBy !== undefined &&
                                      data?.closedBy !== null &&
                                      data?.closedBy !== "" && (
                                        <div class="rounded-circle bg-primary text-center w-75 ">
                                          <p class="text-white m-0 p-0">
                                            {getInitials(data?.closedBy) ||
                                              "NA"}
                                          </p>
                                        </div>
                                      )}
                                  </div>
                                  <div class="col-lg-9 col-md-9">
                                    <div>
                                      <p class="ms-2">{data?.closedBy}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <p class="fw-bold text-secondary">Open since</p>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <p class="fw-bold text-secondary">
                                {calculateTimeDifference(
                                  data?.createdOn,
                                  getTodaytDateTime(),
                                  userTimeZone
                                )}
                                {data?.closedOn}
                              </p>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <p class="fw-bold text-secondary">Closed on</p>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <p class="fw-bold text-secondary">
                                {data?.closedOn}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  {/* <div class="col-lg-12 col-md-12">
                    <div class="d-flex justify-content-between configure">
                      <p class=" ">Created last week</p>
                      <div>
                        <i class="fa-solid fa-gear"></i>
                        <a
                          href="#"
                          class="text-decoration-none text-muted fw-semibold "
                        >
                          Configure
                        </a>
                      </div>
                    </div>
                  </div> */}
                  <div class="col-lg-12 col-md-12 configure">
                    <p>
                      Last Updated on{" "}
                      {calculateTimeDifference(
                        data?.updatedOn,
                        getTodaytDateTime(),
                        userTimeZone
                      )}{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
